export default __webpack_public_path__ + "static/media/kk salah.d6d08456.jpg";